module.exports = "/pages/business/foodslabo/service_icon_7.png";